import { Component, OnInit, ViewChild, HostListener, TemplateRef, Inject } from '@angular/core';

import { PrazoService } from '@app/services/prazo.service';
import { PrazoGerenciamento, PrazoGerenciamentoPesquisa, EncaminharPrazo, PrazoGerenciamentoLista } from '@app/pages/processos/gerenciar-prazos/gerenciar-prazos.model';
import { CDSMask } from '@app/utils/cds-mask';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { ProcessoMovimentacao, TipoMovimentacao } from '@app/models/processo-movimentacao';
import { ToastrService } from 'ngx-toastr';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { MeAvise } from '@app/models/me-avise';

@Component({
  selector: 'app-gerenciar-prazos',
  templateUrl: './gerenciar-prazos.component.html',
  styleUrls: ['./gerenciar-prazos.component.scss']
})
export class GerenciarPrazosComponent implements OnInit {

  @ViewChild('protocolarModal', { static: true }) protocolarModal: TemplateRef<any>;
  @ViewChild('alterarusuarioModal', { static: true }) encaminharModal: TemplateRef<any>;

  modalRef: BsModalRef;

  encaminharPrazo: EncaminharPrazo = new EncaminharPrazo();

  pesquisaFiltro: PrazoGerenciamentoPesquisa;

  lstPrazoGerenciamento: PrazoGerenciamentoLista[] = [];
  lstAdvogados: IdDescricao[];

  cdsMask: CDSMask = new CDSMask();
  bsModalRef: BsModalRef;

  lstProcessoMovimentacao: ProcessoMovimentacao[];

  // encaminhar
  processoId: number;
  tipoMovimentacao: TipoMovimentacao;
  encaminharId: number;
  prazosSelecionados: number[] = [];

  // transferir
  lstUsuarios: IdDescricao[];
  meAvise: MeAvise = new MeAvise();
  data: string;
  prazo: string;
  prazoInterno: string;
  usuarioDestinoId: number;
  lstErros: string[] = [];
  recarregarmodal = true;

  pesquisando: boolean;

  @HostListener('document:keydown', ['$event'])
  atalhoGravar(event: KeyboardEvent) {
    if (event.which === 116) {
      event.preventDefault();
      this.pesquisar();
    }
  }

  constructor(
    public sanitizer: DomSanitizer,
    private prazoService: PrazoService,
    private consultasService: ConsultasService,
    public modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
    this.pesquisaFiltro = new PrazoGerenciamentoPesquisa();
    this.pesquisaFiltro.FiltrarDataPor = 'PRAZO-FATAL';
    // this.pesquisaFiltro.TipoOrdenamento = 'CRESCENTE';
    this.pesquisaFiltro.FuncionarioId = 0;
    this.pesquisaFiltro.Realizado = 1;
    this.pesquisaFiltro.Protocolado = 2;
    this.pesquisaFiltro.Estado = 2;

    // this.pesquisaFiltro.DataInicial = UtilitarioService.retornaDataAtualMaisDias(-60);
    // this.pesquisaFiltro.DataFinal = UtilitarioService.retornaDataAtualMaisDias(7);
    this.lstAdvogados = [];

    this.consultasService.consultar('USUARIO').toPromise().then(data => this.lstUsuarios = data);

  }


  public obterTipoMovimentacao(tipoMovimentacaoId: number) {
    switch (tipoMovimentacaoId) {
      case 1: return 'administrativa';
      case 2: return 'execucao-provisoria';
      case 3: return 'judicial';
    }
  }

  ngOnInit() {

    this.consultasService.consultar('USUARIO').toPromise().then(data => {
      const todos = new IdDescricao();
      todos.Id = 0;
      todos.Descricao = 'Todos os funcionários';
      this.lstAdvogados = [todos, ...data];
    });

    // this.pesquisar();

    // this.protocolarModal.onHidden.subscribe(() => {
    //   this.processoId = null;
    //   this.pesquisar(false);
    // });
  }

  public pesquisar(scrollTo = true) {

    if (scrollTo) {
      this.pesquisando = true;
      window.scrollTo(0, 0);
    }

    this.prazoService.obterPrazoGerenciamento(this.pesquisaFiltro).toPromise().then(listaPrazo => {
      this.lstPrazoGerenciamento = listaPrazo ?? [];
      this.filtrarPrazos(); // TODO: Aparentemente não está sendo utilizado. Remover?
      this.pesquisando = false;
    },
      erro => {
        this.pesquisando = false;
        this.toastr.warning('Realize a pesquisa novamente.');
      });
  }

  concluirPrazo(prazoGerenciamento: PrazoGerenciamento) {
    this.prazoService.concluirPrazo(prazoGerenciamento.Id).toPromise().then(() => {
      prazoGerenciamento.Protocolado = true;
    });
  }

  desconcluir(prazoGerenciamento: PrazoGerenciamento) {
    this.prazoService.desconcluirPrazo(prazoGerenciamento.Id).toPromise().then(() => {
      prazoGerenciamento.Protocolado = false;
    });
  }

  public obterCorStatus(status: string): string {
    switch (status) {
      case 'Atrasado':
        return 'red';
      case 'No prazo':
        return 'green';
      case 'Próximo do prazo':
        return 'yellow';
      case 'Realizado':
        return 'DarkGreen';
    }
  }

  public obterCorStatusRealizado(dataPrazo: string, dataRealizado: string): string {
    if (dataRealizado == null) {
      return 'green';
    } else if (new Date(dataRealizado) > new Date(dataPrazo)) {
      return 'red';
    } else {
      return 'DarkGreen';
    }
  }

  fecharModal() {
    this.recarregarmodal = false;
    this.modalRef.hide();
    this.modalRef = null;
  }

  abreModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }
  public encaminhar(processoId: number, tipoMovimentacao: TipoMovimentacao, encaminharId: number, template: TemplateRef<any>) {
    this.processoId = processoId;
    this.tipoMovimentacao = tipoMovimentacao;
    this.encaminharId = encaminharId;
    // this.modalService.show(this.protocolarModal, {class: 'modal-lg'});
    this.abreModal(template);
  }

  public alterarMovimentacao(tipoMovimentacao: TipoMovimentacao) {
    this.tipoMovimentacao = tipoMovimentacao;
  }


  public alterarUsuario(prazo: PrazoGerenciamento) {

    this.encaminharPrazo.MeAviseId = prazo.EncaminhadoMeAviseId;
    this.encaminharPrazo.UsuarioId = prazo.EncaminhadoUsuarioId;
    this.encaminharPrazo.Descricao = prazo.EncaminhadoMeAviseDescricao;
    this.modalService.show(this.encaminharModal);
  }

  public filtrarPrazos() {
    this.prazosSelecionados = [];
    for (let i = 0; i < this.lstPrazoGerenciamento.length; i++) {
      for (let ii = 0; ii < this.lstPrazoGerenciamento[i].Prazos.length; ii++) {
        if (this.lstPrazoGerenciamento[i].Prazos[ii].checked) {
          this.prazosSelecionados.push(this.lstPrazoGerenciamento[i].Prazos[ii].Id);
        }
      }
    }
  }

  // public concluirSelecionados() {
  //   this.bsModalRef = this.modalService.show(ModalConfirmar);
  //   this.bsModalRef.content.mensagem = "Deseja realmente concluir os prazos selecionados?";
  //   this.bsModalRef.content.confirmar = () => {
  //     this.prazoService.concluirPrazos(this.prazosSelecionados).toPromise().then(() => {
  //       this.pesquisar();

  //     });
  //   }
  // }

  public abreModalTransferencia(id: number, template: TemplateRef<any>) {
    this.meAvise = new MeAvise();
    this.prazoService.obterMeAvise(id).toPromise().then(
      (data: MeAvise) => {
        this.meAvise = data;
        this.data = this.meAvise.Data;
        this.prazo = this.meAvise.Prazo;
        // this.meAvise.Data = this.meAvise.Data.split('T')[0];
        // this.meAvise.Prazo = this.meAvise.Prazo.split('T')[0];
        this.prazoInterno = this.meAvise.PrazoInterno;
        this.usuarioDestinoId = this.meAvise.UsuarioAtualId;
      });
    // this.modalService.show(this.transferirMeAviseModal, Object.assign({}, { class: 'modal-lg modal-xl', id: 1 }));
    this.abreModal(template);
  }

  public transferir() {
    const meAviseTransferir = new MeAvise();
    meAviseTransferir.Data = this.data;
    meAviseTransferir.Prazo = this.prazo;
    meAviseTransferir.PrazoInterno = this.prazoInterno;
    meAviseTransferir.Id = this.meAvise.Id;
    this.prazoService.transferirMeAvise(this.usuarioDestinoId, meAviseTransferir).toPromise()
      .then(() => {
        this.fecharModal();
        this.pesquisar(false);
      },
        (BadRequest) => {
          if (BadRequest.error) {
            this.recarregarmodal = true;
            this.lstErros[0] = BadRequest.error[0]["Valor"];
          }
        }
      );
  }

  realizar(meAviseId: number) {

    this.prazoService.realizarMeAvise(meAviseId).toPromise()
      .then(() => {
        this.fecharModal();
        this.pesquisar(false);
      },
        data => this.toastr.error(data.errors[0]));

  }
}
